module.exports = __webpack_public_path__ + "static/media/car.c01f03e7.svg";